// // MainComponent.js
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import Header from './Header';
// import HomeScreen from './HomeScreen';
// import './MainComponent.css';

// const roles = {
//   SUPERADMIN: 'SuperAdmin',
//   ADMIN: 'Admin',
//   WRITE: 'Write',
//   READ: 'Read',
// };

// function MainComponent() {
//   const [userRole, setUserRole] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);

//   const location = useLocation();
//   const navigate = useNavigate();

//   const [activeButton, setActiveButton] = useState(location.pathname);

//   const handleButtonClick = (path) => {
//     setActiveButton(path);
//   };

//   useEffect(() => {
//     const isUpdating = JSON.parse(localStorage.getItem('isUpdating'));
//     const userData = JSON.parse(localStorage.getItem('userData'));

//     if (isUpdating) return;

//     if (userData) {
//       setUserRole(userData[6]);
//     } else {
//       navigate('/mcv/login');
//       return;
//     }

//     if (
//       ![roles.ADMIN, roles.SUPERADMIN, roles.WRITE, roles.READ].includes(userData[6])
//     ) {
//       navigate('/mcv/login');
//       return;
//     }

//     setLoading(false);
//   }, [navigate]);

//   // Automatically update active button when route changes
//   useEffect(() => {
//     setActiveButton(location.pathname);
//   }, [location.pathname]);

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="main-container">
//       {userRole && (
//         <>
//           <Header toggleSidebar={toggleSidebar} setActiveButton={setActiveButton} />
//           <div className={`content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
//             <HomeScreen
//               isSidebarOpen={isSidebarOpen}
//               activeButton={activeButton}
//               handleButtonClick={handleButtonClick}
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default MainComponent;








//Above solution is for pending approval redirect logic but commented due to multiple API calling at a time











// Updated MainComponent.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Header from './Header';
import HomeScreen from './HomeScreen';
import './MainComponent.css';
import appConfig from "../config/appConfig.json"; // Import loginRoute from appConfig.json

const roles = {
  OWNER: 'Owner',
  SUPERADMIN: 'SuperAdmin',
  ADMIN: 'Admin',
  WRITE: 'Write',
  READ: 'Read',
};

const loginRoute = appConfig.loginRoute;



function MainComponent() {
  const [userRole, setUserRole] = useState(null); // Add userRole state
  const [loading, setLoading] = useState(true); // Add loading state to handle async behavior
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    const isUpdating = JSON.parse(localStorage.getItem('isUpdating')); // Check if an update is in progress
    const userData = JSON.parse(localStorage.getItem('userData')); // Retrieve userData from localStorage
  
    // If an update is in progress, skip role validation to prevent redirects
    if (isUpdating) {
      return;
    }
  
    // Check if userData exists and set the user role
    if (userData) {
      setUserRole(userData[6]); // Assuming the role is stored at index 6 in userData
    } else {
      // Redirect to login if userData is missing
      // navigate('/mcv/login');
      // navigate('/');
      navigate(loginRoute);
      return;
    }
  
    // Validate user role and redirect if invalid
    if (!(userData[6] === roles.ADMIN || [roles.SUPERADMIN, roles.OWNER].includes(userData[6]) || userData[6] === roles.WRITE || userData[6] === roles.READ)) {
      // navigate('/mcv/login');
      // navigate('/');
      navigate(loginRoute);
      return;
    }
  
    // Mark loading as complete if all checks pass
    setLoading(false);
  }, [navigate]);
  

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  if (loading) {
    return <div>Loading...</div>; // Optionally show a loading state while fetching userRole
  }

  return (
    <div className="main-container">
      {userRole && ( // Only render the content if userRole is present and valid
        <>
          <Header toggleSidebar={toggleSidebar} />
          <div className={`content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <HomeScreen isSidebarOpen={isSidebarOpen} />
          </div>
        </>
      )}
    </div>
  );
}

export default MainComponent;
